'use strict'
require('core-js/modules/es.number.to-fixed')
exports.__esModule = true
exports.default = humanizeSize

var _is = require('../is')

var DIVIDER = 1024
var SIZE_NAMES = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb']

/**
 * humanizeSize
 * Переодит байты в человекочитаемую строку
 *
 * @export
 * @param {number} bytes
 * @example
 * humanizeSize(12312334) // '11.7 Mb'
 * @returns {string}
 */
function humanizeSize(bytes) {
  if (!(0, _is.isNum)(bytes) || bytes < 1) return '0 Kb'
  var ind = 1
  var count = bytes
  while (bytes / Math.pow(DIVIDER, ind) >= 1) {
    count = bytes / Math.pow(DIVIDER, ind)
    ind++
  }

  return count.toFixed(1) + ' ' + SIZE_NAMES[ind - 1]
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/misc/humanizeSize.js
// module id = 640
// module chunks = 0